import { render, staticRenderFns } from "./ReviewOverview.vue?vue&type=template&id=39e781ec&scoped=true"
import script from "./ReviewOverview.vue?vue&type=script&lang=js"
export * from "./ReviewOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e781ec",
  null
  
)

export default component.exports